import { Instance, types } from 'mobx-state-tree'

export enum AddressType {
  Business = 'Business',
  Residential = 'Residential',
}

const Address = types
  .model('Address', {
    id: types.string, //  mid / tid
    type: types.optional(types.enumeration(Object.values(AddressType)), AddressType.Business),
    line1: types.string,
    line2: types.string,
    pincode: types.string,
    city: types.string,
    state: types.string,
    country: types.string,
  })
  .views((self) => ({
    printAddress(): string {
      return `${self.line1} ${self.line2} ${self.city} ${self.state} ${self.country} ${self.pincode}`
    },
  }))

const addressData = Address.create({
  id: '0',
  type: AddressType.Business,
  line1: '#1 RPC',
  line2: 'Ground Floor T1',
  pincode: '400001',
  city: 'Mumbai',
  state: 'Maharashtra',
  country: 'India',
})

const addressData1 = Address.create({
  id: '1',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

const addressData2 = Address.create({
  id: '2',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

const addressData3 = Address.create({
  id: '3',
  type: AddressType.Business,
  line1: '#33',
  line2: '2nd main',
  pincode: '560001',
  city: 'Bangalore',
  state: 'Karnataka',
  country: 'India',
})

const addressData4 = Address.create({
  id: '4',
  type: AddressType.Business,
  line1: '#12',
  line2: '1st Cross',
  pincode: '560001',
  city: 'Bangalore',
  state: 'Karnataka',
  country: 'India',
})

const addressData5 = Address.create({
  id: '5',
  type: AddressType.Business,
  line1: '#1, Marine Drive',
  line2: 'RCP',
  pincode: '400012',
  city: 'Mumbai',
  state: 'Maharashtra',
  country: 'India',
})

const addressData6 = Address.create({
  id: '6',
  type: AddressType.Residential,
  line1: '#1, Bandra main road',
  line2: 'Bandra',
  pincode: '400001',
  city: 'Mumbai',
  state: 'Maharashtra',
  country: 'India',
})

const addressData7 = Address.create({
  id: '7',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

const addressData8 = Address.create({
  id: '8',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

const addressData9 = Address.create({
  id: '9',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

const addressData10 = Address.create({
  id: '10',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

const addressData11 = Address.create({
  id: '11',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

const addressData12 = Address.create({
  id: '12',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

const addressData13 = Address.create({
  id: '13',
  type: AddressType.Business,
  line1: '',
  line2: '',
  pincode: '',
  city: '',
  state: '',
  country: '',
})

export type AddressV2 = Instance<typeof Address>
export {
  Address,
  addressData,
  addressData1,
  addressData2,
  addressData3,
  addressData4,
  addressData5,
  addressData6,
  addressData7,
  addressData8,
  addressData9,
  addressData10,
  addressData11,
  addressData12,
  addressData13,
}
